/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SupportedLanguages from '../../models/enums/SupportedLanguages';

const initialState = {
  user: null,
  suivis: null,
  clients: null,
  visites: null,
  language: SupportedLanguages.DEFAULT,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    updateLanguage(state, action: PayloadAction<any>) {
      state.language = action.payload;
    },
    updateSuivis(state, action: PayloadAction<any>) {
      state.suivis = action.payload;
    },
    updateVisites(state, action: PayloadAction<any>) {
      state.visites = action.payload;
    },
    updateClients(state, action: PayloadAction<any>) {
      state.clients = action.payload;
    },
  },
});

export const {
  updateUser,
  updateLanguage,
  updateSuivis,
  updateVisites,
  updateClients,
} = userSlice.actions;

export default userSlice;
